import React, { useEffect, useState } from 'react'
import InputMask from 'react-input-mask'
import api from '../components/api'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { dataTableRender, validaCPF } from '../components/functions'


const AdesaoIndividual = (props) => {


    const history = useHistory()

    var adesao_individual_id = props.match.params.adesao_individual_id


    var [confirmaApoio, setConfirmaApoio] = useState('')
    var [cpf, setCPF] = useState('')
    var [nome, setNome] = useState('')
    var [email, setEmail] = useState('')

    var [listaOrganizacao, setListaOrganizacao] = useState()
    var [categoriaProfissional, setCategoriaProfissional] = useState()

    var [senha, setSenha] = useState('')
    var [confirmaSenha, setConfirmaSenha] = useState('')

    var [nome_organizacao, setNomeOrganizacao] = useState('')
    var [email, setEmail] = useState('')
    var [bairro, setBairro] = useState('')
    var [data_nascimento, setDataNascimento] = useState('')
    var [cpf, setCpf] = useState('')
    var [nome, setNome] = useState('')
    var [confirmaEmail, setConfirmaEmail] = useState('')
    var [senha, setSenha] = useState('')
    var [sexo, setSexo] = useState('')
    var [telefone_comercial, setTelefoneComercial] = useState('')
    var [telefone_residencial, setTelefoneResidencial] = useState('')
    var [cep, setCep] = useState('')
    var [endereco, setEndereco] = useState('')
    var [municipio, setMunicipio] = useState('')
    var [numero, setNumero] = useState('')
    
    var [categoria_profissional_id, setCategoriaProfissionalId] = useState('')
    var [organizacao_tipo_id, setOrganizacaoTipo] = useState('')
    var [organizacao_id, setOrganizacao] = useState('')
    var [cargo, setCargo] = useState('')
    var [uf_codigo, setUF] = useState('')

    var [listaUF, setListaUF] = useState()
    var [totalEventos, setTotalEventos] = useState()

    var [participacoes, setParticipacoes] = useState()
    


    async function carregaDados() {

        if (adesao_individual_id) {


            await api.get(`adesaoIndividualListaUm/${adesao_individual_id}`).then((result) => {

                //console.log(result.data)

                var data = result.data[0]

                if (data) {

                    

                    setCpf(data.cpf)
                    setNome(data.nome)
                    setBairro(data.bairro)
                    setEmail(data.email)
                    setDataNascimento(data.data_nascimento)
                    setSexo(data.sexo)
                    setTelefoneComercial(data.telefone_comercial)
                    setTelefoneResidencial(data.telefone_residencial)
                    setCep(data.cep)
                    setEndereco(data.endereco)
                    setNumero(data.numero)
                    setMunicipio(data.municipio)
                    setUF(data.uf_codigo)
                    setCategoriaProfissionalId(data.categoria_profissional_id)
                    setOrganizacaoTipo(data.organizacao_tipo_id)
                    setOrganizacao(data.organizacao_id)
                    setNomeOrganizacao(data.nome_organizacao)
                    setCargo(data.cargo)
                    setTotalEventos(data.totalEventos)
                    

                }

                

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    async function adesaoIndividualListaOrganizacao() {

        await api.get('adesaoIndividualListaOrganizacao/pt').then((response) => {
            
            if (response.data) {

                setListaOrganizacao(response.data.map((rs) => 
                    <option value={rs.organizacao_tipo_id}>
                        {rs.descricao}
                    </option>
                ))

            }


        }).catch((err) => {
            console.log(err.response)
        })

    }


    async function adesaoIndividualCategoriaProfissional() {

        await api.get('adesaoIndividualCategoriaProfissional/pt').then((response) => {
            //console.log(response.data)

            setCategoriaProfissional(response.data.map((rs) => 
                <option value={rs.categoria_profissional_id}>
                    {rs.descricao}
                </option>
            ))

        }).catch((err) => {
            console.log(err.response)
        })

    }



    async function carregaUF() {

        await api.get('uf').then((response) => {
            //console.log(response.data)
            setListaUF(response.data.map((rs) =>

                <option value={rs.uf_codigo} key={rs.uf_codigo}>{rs.uf_codigo}</option>
            
            ))
        }).catch((err) => {
            console.log(err.response)
        })


    }



    async function consultaCEP() {

        

        if (cep.replaceAll('-', '').length == 8) {

            await axios.get(`https://viacep.com.br/ws/${cep.replaceAll('-', '')}/json/`).then((response) => {

                //console.log(response.data)
                setEndereco(response.data.logradouro)
                setBairro(response.data.bairro)
                setMunicipio(response.data.localidade)
                setUF(response.data.uf)
                

            }).catch((err) => {
                console.log(err.response)
            })

        }

    }


    


    function salvar() {



        if (!validaCPF(cpf.replaceAll('-', '').replaceAll('.',''))) {

            window.toastr.error('<b>CPF</b> inválido!')
            return false;

        }



        if (nome == '') {

            window.toastr.error('<b>Nome</b> não pode ficar em branco!')
            return false

        }


        if (sexo == '') {

            window.toastr.error('<b>Sexo</b> não pode ficar em branco!')
            return false

        }


        if (numero == '') {

            window.toastr.error('<b>Número</b> não pode ficar em branco!')
            return false

        }


        if (bairro == '') {

            window.toastr.error('<b>Bairro</b> não pode ficar em branco!')
            return false

        }

        if (endereco == '') {

            window.toastr.error('<b>Endere&ccedil;o</b> não pode ficar em branco!')
            return false

        }


        if (cep == '') {

            window.toastr.error('<b>CEP</b> não pode ficar em branco!')
            return false

        }


        if (telefone_residencial == '') {

            window.toastr.error('<b>Telefone celular ou residencial</b> não pode ficar em branco!')
            return false

        }

        if (categoria_profissional_id == '') {

            window.toastr.error('<b>Categoria profissional</b> não pode ficar em branco!')
            return false

        }



        if (municipio == '') {

            window.toastr.error('<b>Município</b> não pode ficar em branco!')
            return false

        }


        if (uf_codigo == '') {

            window.toastr.error('<b>UF</b> não pode ficar em branco!')
            return false

        }

        if (organizacao_tipo_id == '') {

            window.toastr.error('<b>Tipo de organização você trabalha</b> não pode ficar em branco!')
            return false

        }

        if (organizacao_id == '') {

            window.toastr.error('<b>Organização</b> não pode ficar em branco!')
            return false

        }


        if (nome_organizacao == '') {

            window.toastr.error('<b>Nome da organização em que trabalha</b> não pode ficar em branco!')
            return false

        }

        



        var dataPost = {

            nome_organizacao: nome_organizacao,
            email: email,
            bairro: bairro,
            data_nascimento: data_nascimento,            
            cpf: cpf.replaceAll('-', '').replaceAll('.',''),
            nome: nome,
            sexo: sexo,
            telefone_comercial: telefone_comercial,
            telefone_residencial: telefone_residencial,
            cep: cep,
            endereco: endereco,
            municipio: municipio,
            numero: numero,
            uf_codigo: uf_codigo,
            categoria_profissional_id: categoria_profissional_id,
            organizacao_tipo_id: organizacao_tipo_id,
            organizacao_id: organizacao_id,
            cargo: cargo,

        }

        


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {


                    api.put(`adesaoIndividual/${adesao_individual_id}`, dataPost).then((result) => {

                        console.log(result.data)
                        //history.push('/Obrigado')
                        window.toastr.success('Registro salvo com sucesso!')

            
                    }).catch((err) => {
            
                        console.log(err.response)
            
                    })

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }

    async function participacoesEventos() {


        await api.get(`eventosInscrito/${adesao_individual_id}`).then((result) => {

            //console.log(result.data)

            setParticipacoes(result.data.map((rs) =>

                <tr>
                    <td>
                        {rs.data_inicio}
                    </td>
                    <td style={{ width: '50%'}}>
                        {rs.nome}
                    </td>
                    <td>
                        <center>
                        {rs.confirmado ? 'Sim' : !rs.confirmado ? 'Não' : '' }
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.presente ? 'Sim' : !rs.presente ? 'Não' : '' }
                        </center>
                    </td>
                </tr>
            
            ))

            dataTableRender('tabelaParticipacoesEventos')
            

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        consultaCEP()
        carregaUF()

        
    }, [cep])




    async function verificaPermissao() {


        if (sessionStorage.getItem('permAdesoes') != 'true') {

            history.push('/')

        }


    }


    useEffect(() => {

        //console.log(adesao_individual_id)

        verificaPermissao()

        adesaoIndividualCategoriaProfissional()
        adesaoIndividualListaOrganizacao()
        carregaDados()
        

    }, [])



    return (


        <div>


<div>
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-add-user'></i>
                </div>
                <div class='header-title'>
                    <h1>Ades&atilde;o Individual</h1>
                    <small>Administração</small>
                    
                </div>
            </div>



            <div class="row">
                
                <div class="col-sm-12">
                    


                    <ul class="nav nav-tabs">
                            <li class="active"><a href="#tab1" data-toggle="tab">Dados pessoais</a></li>
                            <li><a href="#tab2" data-toggle="tab">Dados Profissionais</a></li>
                            <li><a href="#tab3" data-toggle="tab" onClick={() => participacoesEventos()}>Participações em eventos ({totalEventos})</a></li>
                            
                        </ul>
                        
                        <div class="tab-content">
                            <div class="tab-pane fade in active" id="tab1">
                                <div class="panel-body">





                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            <label className="control-label">CPF:</label>
                                            <InputMask mask="999.999.999-99" class="form-control" value={cpf} onChange={event => setCpf(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-9" >
                                        <div class="form-group" >
                                            <label className="control-label">Nome completo: *</label>
                                            <input class="form-control" value={nome} onChange={event => setNome(event.target.value)} style={{ 'text-transform': 'uppercase'}} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label">E-mail: *</label>
                                            <input class="form-control" value={email} onChange={event => setEmail(event.target.value)} style={{ 'text-transform': 'lowercase'}}  />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-12" style={{ display: 'none' }}>
                                        <div class="form-group" >
                                            <label className="control-label">Favor redigitar para confirmar seu E-mail: *</label>
                                            <input class="form-control" value={confirmaEmail} onChange={event => setConfirmaEmail(event.target.value)} style={{ 'text-transform': 'lowercase'}}  />
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-12"  style={{ display: 'none' }}>
                                        <div class="form-group" >
                                            <label className="control-label">Crie uma senha para acessar a rede e editar os seus dados: *</label>
                                            <input type="password" class="form-control" value={senha} onChange={event => setSenha(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-12"  style={{ display: 'none' }}>
                                        <div class="form-group" >
                                            <label className="control-label">Confirme sua senha: *</label>
                                            <input type="password" class="form-control" value={confirmaSenha} onChange={event => setConfirmaSenha(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <label className="control-label">Data de nascimento: *</label>
                                            <input type="text" class="form-control" value={data_nascimento}  onChange={event => setDataNascimento(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <label className="control-label">Sexo: *</label>
                                            <select class="form-control" onChange={event => setSexo(event.target.value)} value={sexo}>
                                                <option value="">[Selecione]</option>
                                                <option value="M">Masculino</option>
                                                <option value="F">Feminino</option>
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <label className="control-label">Telefone comercial: *</label>
                                            <input type="text" class="form-control" value={telefone_comercial}  onChange={event => setTelefoneComercial(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <label className="control-label">Telefone celular ou residencial: </label>
                                            <input type="text" class="form-control" value={telefone_residencial}  onChange={event => setTelefoneResidencial(event.target.value)} />
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            <label className="control-label">CEP: *</label>
                                            <InputMask mask="99999-999" type="text" class="form-control" value={cep}  onChange={event => setCep(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-9" >
                                        <div class="form-group" >
                                            <label className="control-label">Endereço: *</label>
                                            <input type="text" class="form-control" value={endereco}  onChange={event => setEndereco(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-8" >
                                        <div class="form-group" >
                                            <label className="control-label">Bairro: *</label>
                                            <input type="text" class="form-control" value={bairro}  onChange={event => setBairro(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <label className="control-label">Número: *</label>
                                            <input type="text" class="form-control" value={numero}  onChange={event => setNumero(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-9" >
                                        <div class="form-group" >
                                            <label className="control-label">Município: *</label>
                                            <input type="text" class="form-control" value={municipio}  onChange={event => setMunicipio(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            <label className="control-label">UF: *</label>
                                            <select class="form-control" value={uf_codigo} onChange={event => setUF(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {listaUF}
                                            </select>
                                                
                                        </div>
                                    </div>

                               
                                </div>

                            </div>
                            <div class="tab-pane fade in" id="tab2">
                                <div class="panel-body">
                                        
                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label">Categoria profissional: *</label>
                                            <select class="form-control" value={categoria_profissional_id} onChange={event => setCategoriaProfissionalId(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {categoriaProfissional}
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label">Em que tipo de organização você trabalha? *</label>
                                            <select class="form-control" value={organizacao_tipo_id} onChange={event => setOrganizacaoTipo(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {listaOrganizacao}
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label">Organização: *</label>
                                            <select class="form-control"  value={organizacao_id} onChange={event => setOrganizacao(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="2" >Privada com fins de lucro</option>
                                            <option value="3" >Privada sem fins de lucro</option>
                                            <option value="1" >Pública</option>
                        
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label">Nome da organização em que trabalha: *</label>
                                            <input type="text" class="form-control" value={nome_organizacao}  onChange={event => setNomeOrganizacao(event.target.value)} style={{ 'text-transform': 'uppercase'}} />
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <label className="control-label">Cargo ou função que exerce: *</label>
                                            <input type="text" class="form-control" value={cargo}  onChange={event => setCargo(event.target.value)} style={{ 'text-transform': 'uppercase'}} />
                                                
                                        </div>
                                    </div>



                                </div>

                            </div>
                            <div class="tab-pane fade in" id="tab3">
                                <div class="panel-body">
                                    
                                <div className="table-responsive">
                                    <table id="tabelaParticipacoesEventos" className="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Data evento</th>
                                                <th style={{ width: '50%'}}>Evento</th>
                                                <th><center>Confirmado</center></th>
                                                <th><center>Presente</center></th>
                                                                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {participacoes}
                                        </tbody>
                                        
                                    </table>
                                </div>

                                </div>
                            </div>
                        </div>
                    

                </div>




        <div class="col-md-12">

            <br/>
                            
            <button type="button" class="btn btn-info" onClick={() => history.push('/AdesaoIndividual')}>Voltar</button>&nbsp;
            <button type="button" class="btn btn-warning"  disabled>Alterar senha</button>&nbsp;
            
            <button type="button" class="btn btn-primary" onClick={() => salvar()}>Salvar</button>

        </div>



            </div>


        </div>



        </div>


    )

}

export default AdesaoIndividual